import React from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import CheckoutButton from '../components/payment/CheckoutButton';

const SubscriptionRequiredPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut({ scope: 'local' });
    navigate('/', { replace: true });
  };

  return (
    <div className="min-h-screen bg-surface-bg flex flex-col justify-center items-center text-center py-12 px-6 sm:px-8 lg:px-12">
      <div className="bg-surface-card rounded-xl shadow-sm border border-surface-border p-8 sm:p-12 max-w-2xl w-full">
        <h2 className="font-display tracking-tight text-2xl sm:text-3xl font-bold text-text-primary mb-3">Subscription Required</h2>
        <p className="font-sans text-base text-text-body mb-8">
          Your organization needs an active subscription to access this content.
        </p>
        <div className="mb-6 text-left">
          <CheckoutButton />
        </div>
        <div className="flex flex-col items-center gap-3">
          <button
            onClick={handleLogout}
            className="text-sm font-semibold text-accent-blue hover:text-accent-blue-hover hover:underline transition-colors"
          >
            Log Out
          </button>
          <a
            href="mailto:cwatford@averworx.com"
            className="text-sm font-sans text-text-muted hover:text-text-body transition-colors"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionRequiredPage;

export {};
